import { useCallback } from "react";
import { Grid, Divider, Typography } from "@material-ui/core";
import { Box, Button, List, ListItem } from "~/components/UI";
import Highlighter from "react-highlight-words";
import history from "~/packages/history";
import ROUTES from "~/constants/routes";
import { useTranslation } from "react-i18next";

interface AcquirersResultProps {
  data?: Api.SearchResult<AcquirersApi.SearchResult>;
  searchQuery: string;
}

const Acquirer = ({
  acquirer,
  searchQuery,
}: {
  searchQuery: string;
  acquirer: AcquirersApi.SearchResult;
}) => {
  const openGroup = useCallback(() => {
    history.push(`${ROUTES.ACQUIRERS}?acquirerId=${acquirer.id}`);
  }, [acquirer.acquirerId]);

  return (
    <ListItem button onClick={openGroup}>
      <Typography variant="body2" color="textSecondary">
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={acquirer.acquirerName}
        />{" "}
        [
        <Typography variant="body2" component="span" color="primary">
          ID
        </Typography>
        :{" "}
        <Highlighter
          searchWords={[searchQuery]}
          textToHighlight={acquirer.id}
        />
        ]
      </Typography>
      <Divider />
    </ListItem>
  );
};

/**
 * @memberof GlobalSearch
 * @component
 * @desc Render of search results for the Acquirers catalog.
 * @property {string} searchQuery - the text we are looking for
 * @property {Api.SearchResult<AcquirersApi.SearchResult>} data - api response
 */

const Acquirers = ({ data, searchQuery }: AcquirersResultProps) => {
  const { t } = useTranslation();

  const onShowAll = useCallback(() => {
    setTimeout(() => {
      history.push(`${ROUTES.ACQUIRERS}?search=${searchQuery}`);
    }, 0);
  }, [searchQuery]);

  if (data && data.count) {
    return (
      <Box mb={4}>
        <Box py={4}>
          <Grid container alignItems="center">
            <Grid item sm>
              <Typography variant="subtitle1">
                {t("title.catalogAcquirers")} ({data.count})
              </Typography>
            </Grid>
            <Grid item>
              <Button variant="outlined" onClick={onShowAll}>
                {t("button.showAll")}
              </Button>
            </Grid>
          </Grid>
        </Box>
        <List>
          {data.data.map((u, index) => (
            <Acquirer key={index} searchQuery={searchQuery} acquirer={u} />
          ))}
        </List>
      </Box>
    );
  } else {
    return null;
  }
};

export default Acquirers;
